import styled from 'styled-components';

export const OffScreen = styled.div`
    position: absolute;
    left: -5000px;
`;

